import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { userChatProfileService } from '../api/userChatProfileService';
import type { UserChatProfileState, UserChatProfileActions } from './types';

const initial: UserChatProfileState = {
    selection: null,
    status: RequestStatus.Idle,
    error: null
};

let revision = 0;

/** Хранит выбранный профиль и отбрасывает ответы прежней сессии */
export const useUserChatProfile = create<UserChatProfileState & UserChatProfileActions>((set) => ({
    ...initial,

    select: (selection) => {
        revision += 1;

        set({
            selection,
            status: selection
                ? RequestStatus.Success
                : RequestStatus.Idle,
            error: null,
        });
    },

    load: async (id, role) => {
        const current = ++revision;

        set({
            ...initial,
            status: RequestStatus.Loading
        });

        try {
            const selection = await userChatProfileService.getById(id, role);

            if (current !== revision) return;

            set({
                selection,
                status: RequestStatus.Success
            });
        } catch {
            if (current !== revision) return;

            set({
                status: RequestStatus.Error,
                error: 'Не удалось загрузить выбранного пользователя'
            });
        }
    },

    reset: () => {
        revision += 1;
        set(initial);
    },
}));
